<template>
  <div
    v-if="useTransScale"
    :class="`good-tag-${refId} good-tag`"
    :style="{
      'background-color': !hasBackground
        ? 'none'
        : bgColor.length
        ? bgColor
        : secondaryColor.length
        ? secondaryColor
        : 'none',
      border:
        hasBorder && secondaryColor.length
          ? `1px solid ${secondaryColor}`
          : 'none',
      'border-radius': `${cornerRadius * 2}px`,
      transform: `scale(${transScale})`,
      ...tagStyle
    }"
  >
    <span :style="{ color: primaryColor, fontSize: `${fontSize * 2}px` }"
      ><slot></slot
    ></span>
  </div>
  <div
    v-else
    :class="[
      'tag',
      {
        'has-margin': hasMargin,
        'no-bottom': noBottomMargin
      }
    ]"
    :style="{
      'background-color': !hasBackground
        ? 'none'
        : bgColor.length
        ? bgColor
        : secondaryColor.length
        ? secondaryColor
        : 'none',
      border:
        hasBorder && secondaryColor.length
          ? `1px solid ${secondaryColor}`
          : 'none',
      'border-radius': `${cornerRadius}px`,
      padding: `${paddingTopBottom}px ${paddingLeftRight}px`,
      ...tagStyle
    }"
  >
    <span
      :style="{
        color: primaryColor,
        fontSize: `${fontSize}px`,
        fontWeight: bold ? 'bold' : ''
      }"
      :class="['tag-text', textEllipsis ? 'text-ellipsis' : '']"
      ><slot></slot
    ></span>
  </div>
</template>

<script>
export default {
  props: {
    hasBorder: {
      type: Boolean,
      default: false
    },
    hasBackground: {
      type: Boolean,
      default: false
    },
    primaryColor: {
      type: String,
      default: ''
    },
    secondaryColor: {
      type: String,
      default: ''
    },
    cornerRadius: {
      type: Number,
      default: 4
    },
    bgColor: {
      type: String,
      default: ''
    },
    transScale: {
      type: Number,
      required: false,
      default: 0.5
    },
    tagStyle: {
      type: Object,
      default: () => {}
    },
    fontSize: {
      type: Number,
      default: 10
    },
    useTransScale: {
      type: Boolean,
      default: true
    },
    hasMargin: {
      type: Boolean,
      default: false
    },
    bold: {
      type: Boolean,
      default: false
    },
    noBottomMargin: {
      type: Boolean,
      default: false
    },
    paddingTopBottom: {
      type: Number,
      default: 0
    },
    paddingLeftRight: {
      type: Number,
      default: 0
    },
    textEllipsis: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      refId: Math.random().toString().substr(3, 9)
    }
  },
  mounted() {
    if (this.useTransScale) {
      // 安卓端标签居中兼容
      this.$nextTick(() => {
        const tagDom = document.querySelector(`.good-tag-${this.refId}`)
        const boundClient = tagDom.getBoundingClientRect()
        const cacheMarginRight = boundClient.width
        const cacheMarginBottom = boundClient.height
        const marginRight = `-${cacheMarginRight - 4}px`
        const marginBottom = `-${cacheMarginBottom - 4}px`
        tagDom.style.marginRight = marginRight
        tagDom.style.marginBottom = marginBottom
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.good-tag {
  display: inline-table;

  // transform: scale(0.5);

  height: 30px;
  padding: 4px 10px;

  white-space: nowrap;
  box-sizing: border-box;
  transform-origin: 0 0;

  span {
    display: table-cell;

    flex: none;

    font-size: 20px;

    vertical-align: middle;
  }
}

.tag {
  position: relative;

  margin: 0;
  padding: 0 3px;

  flex: none;

  white-space: nowrap;

  @include flex-row-center;
  &.has-margin {
    margin: 0 4px 4px 0;
  }
  &.no-bottom {
    margin: 0 4px 0 0;
  }
  &.no-margin {
    margin: 0;
  }
  .tag-text {
    flex: none;

    font-size: 9px;

    line-height: 14px;
  }
  .tag-icon-wrapper {
    position: absolute;

    overflow: hidden;
  }
  .tag-icon {
    display: block;

    height: 100%;

    flex: none;
  }
  .icon-tag-text {
    padding-right: 4px;

    padding-left: 15px;
  }
  .text-ellipsis {
    max-width: 100%;
    @include text-overflow-ellipsis;
  }
}
</style>
